import { authFetch } from '../utils/authFetch';

export interface SendCollectionReminderWARequest {
  conversationId: string;
  templateName: string;
  templateVariables: Record<string, string>;
}

export interface SendCollectionReminderWAResponse {
  success: boolean;
  message?: string;
  error?: string;
  conversationId?: string;
  messageId?: string;
}

class ClickSendCollectionReminderService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:8000';
  }

  async sendCollectionReminderWA(
    request: SendCollectionReminderWARequest,
    accessToken: string,
    setUserAndToken: (user: any, token: string) => void
  ): Promise<SendCollectionReminderWAResponse> {
    try {
      // Debug logging
      console.log('Frontend sending request:', JSON.stringify(request, null, 2));
      
      const response = await authFetch(
        `${this.baseUrl}/api/v1/admin/click-send-collection-reminder-wa`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(request)
        },
        accessToken,
        setUserAndToken
      );

      if (response.ok) {
        const data = await response.json();
        return {
          success: true,
          message: 'Collection reminder sent successfully',
          conversationId: data.conversation_id,
          messageId: data.message_id
        };
      } else {
        const errorData = await response.json().catch(() => ({}));
        return {
          success: false,
          error: errorData.detail || 'Failed to send collection reminder'
        };
      }
    } catch (error: any) {
      return {
        success: false,
        error: error.message || 'Failed to send collection reminder'
      };
    }
  }
}

export const clickSendCollectionReminderService = new ClickSendCollectionReminderService();
